export const councilAnnouncementTemplates = {
  production: '68e7a961c97d9637ce48d4ea',
  development: '68e776b509315cf576fb3c0a',
  test: '68e776b509315cf576fb3c0a',
};

export const councilActTemplates = {
  production: '6596babcc144a8a576f0504c',
  development: '673f06d8017ac93cf245491b',
  test: '673f06d8017ac93cf245491b',
};

export const councilActCertificateTemplates = {
  production: '6596babcc144a8a576f0504f',
  development: '66cc7065f350e9752931cff7',
  test: '66cc7065f350e9752931cff7',
};
